import { render, staticRenderFns } from "./DialogEditEmergencyContact.vue?vue&type=template&id=3b352086"
import script from "./DialogEditEmergencyContact.vue?vue&type=script&lang=js"
export * from "./DialogEditEmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports